import { useNavigate } from "react-router-dom";
import { Row, Tooltip } from "@narmi/design_system";
import styles from "./TransferTilesMenu.module.scss";
import useTextOverflowTooltip from "./useTextOverflowTooltip";

type OtherItemTileProps = {
  redirect: string;
  icon: string;
  header: string;
  subHeader: string;
  onClick?: () => void;
};

const OtherItemTile = ({
  redirect,
  icon,
  header,
  subHeader,
  onClick,
}: OtherItemTileProps) => {
  const navigate = useNavigate();
  const { isOverflowing, textRef, tooltipMaxWidth } = useTextOverflowTooltip({
    dependency: subHeader,
  });

  const handleClick = () => {
    if (onClick) {
      onClick();
      return;
    }

    navigate(redirect);
  };

  return (
    <button
      className={`button--reset ${styles.otherItem}`}
      onClick={handleClick}
    >
      <Row alignItems="center" gapSize="s">
        <Row.Item shrink>
          <div
            className={`nds-icon-button nds-icon-button--themed ${styles.IconWrapper}`}
          >
            <span
              className={`${icon}`}
              aria-hidden="true"
              style={{ fontSize: "20px" }}
            />
          </div>
        </Row.Item>
        <Row.Item className={styles.tileTextItem}>
          <div className={styles.tileTextContent}>
            <div
              className={`fontSize--18px fontWeight--semibold ${styles.tileTextHeader}`}
            >
              {header}
            </div>
            {isOverflowing ? (
              <Tooltip
                maxWidth={tooltipMaxWidth}
                text={`${subHeader}`}
                side="bottom"
                wrapperDisplay="block"
              >
                <p
                  ref={textRef}
                  className={`fontSize--16px ${styles.tileTextSubHeader}`}
                >
                  {subHeader}
                </p>
              </Tooltip>
            ) : (
              <p
                ref={textRef}
                className={`fontSize--16px ${styles.tileTextSubHeader}`}
              >
                {subHeader}
              </p>
            )}
          </div>
        </Row.Item>
        <Row.Item shrink>
          <i
            className={`narmi-icon-chevron-right ${styles.chevronIcon}`}
            style={{ fontSize: "24px" }}
          />
        </Row.Item>
      </Row>
    </button>
  );
};

export default OtherItemTile;
